(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["3z-product-layers"] && !Shopify.designMode) return;
  try {
    
  // Initialize firmness tabs, hotspot carousel, and variant sync for one section instance.
  function initProductLayers(root) {
    // Bail if the section root is missing from the DOM.
    if (!root) return;

    const panels = [...root.querySelectorAll('[data-layer-panel]')];
    const visuals = [...root.querySelectorAll('[data-layer-visual]')];
    const tabs = [...root.querySelectorAll('[data-layer-tab]')];
    const mobile = window.matchMedia('(max-width: 768px)');
    const variantOption = root.getAttribute('data-variant-option') || 'option1';
    let variants = [];

    // Parse embedded variant JSON for PDP option matching.
    try {
      variants = JSON.parse(root.querySelector('[data-bb-layers-variants]')?.textContent || '[]');
    } catch (e) {}

    // Return the visible firmness panel for the active tab.
    const activePanel = () => panels.find((panel) => !panel.hidden);
    // Return the visible layer image stack for the active tab.
    const activeVisual = () => visuals.find((visual) => !visual.hidden);
    // Return all hotspot cards inside a panel.
    const slideCards = (panel) => [...panel.querySelectorAll('[data-slide-card]')];

    // Translate the carousel track so the selected card aligns in the viewport.
    function moveTrack(panel, slideIndex) {
      const track = panel.querySelector('[data-carousel-track]');
      const cards = slideCards(panel);
      const cardIndex = cards.findIndex((card) => Number(card.dataset.slide) === slideIndex);
      const card = cards[cardIndex];
      // Skip if the track or target card cannot be resolved.
      if (!track || !card || cardIndex < 0) return;
      track.style.transform = cardIndex > 0 ? 'translateX(-' + card.offsetLeft + 'px)' : 'translateX(0)';
    }

    // Keep cards, dot indicators, hotspots, and track position on the same slide.
    function syncSlide(panel, visual, index) {
      // No-op when the firmness panel is not in the DOM.
      if (!panel) return;

      panel.querySelectorAll('[data-slide-card]').forEach((card) => {
        card.setAttribute('aria-current', Number(card.dataset.slide) === index ? 'true' : 'false');
      });

      panel.querySelectorAll('[data-indicator]').forEach((indicator) => {
        indicator.setAttribute('aria-selected', Number(indicator.dataset.indicator) === index ? 'true' : 'false');
      });

      // Mirror active state on the layer image hotspots when a visual is present.
      if (visual) {
        visual.querySelectorAll('[data-hotspot]').forEach((hotspot) => {
          hotspot.setAttribute('aria-current', Number(hotspot.dataset.hotspot) === index ? 'true' : 'false');
        });
      }

      moveTrack(panel, index);
    }

    // Switch firmness tab: show matching panel + visual and reset to the first hotspot.
    function setLayer(index) {
      panels.forEach((panel, i) => { panel.hidden = i !== index; });
      visuals.forEach((visual, i) => { visual.hidden = i !== index; });
      tabs.forEach((tab, i) => tab.setAttribute('aria-selected', i === index ? 'true' : 'false'));

      const panel = panels[index];
      const visual = visuals[index];
      // Guard against an out-of-range tab index.
      if (!panel) return;

      const firstCard = panel.querySelector('[data-slide-card]');
      syncSlide(panel, visual, firstCard ? Number(firstCard.dataset.slide) : 0);
    }

    // Activate a hotspot slide within the current firmness layer.
    function setSlide(index) {
      syncSlide(activePanel(), activeVisual(), index);
    }

    // Delegate clicks from tabs, cards, hotspots, and indicators.
    root.addEventListener('click', (event) => {
      const tab = event.target.closest('[data-layer-tab]');
      // Firmness tab click — switch layer and reset carousel.
      if (tab && root.contains(tab)) return setLayer(Number(tab.dataset.layerTab));

      const card = event.target.closest('[data-slide-card]');
      // Card click — select that hotspot slide.
      if (card && root.contains(card)) return setSlide(Number(card.dataset.slide));

      const hotspot = event.target.closest('[data-hotspot]');
      // Hotspot click on the layer image — select matching slide.
      if (hotspot && root.contains(hotspot)) return setSlide(Number(hotspot.dataset.hotspot));

      const indicator = event.target.closest('[data-indicator]');
      // Dot indicator click — select matching slide.
      if (indicator && root.contains(indicator)) return setSlide(Number(indicator.dataset.indicator));
    });

    // Mobile swipe to advance the card carousel.
    root.querySelectorAll('[data-carousel-viewport]').forEach((viewport) => {
      let startX = 0;
      let startY = 0;
      let tracking = false;

      viewport.addEventListener('touchstart', (event) => {
        // Swipe handling is mobile-only.
        if (!mobile.matches) return;
        startX = event.touches[0].clientX;
        startY = event.touches[0].clientY;
        tracking = true;
      }, { passive: true });

      viewport.addEventListener('touchend', (event) => {
        // Ignore touchend when not tracking or on desktop.
        if (!tracking || !mobile.matches) return;
        tracking = false;

        const dx = event.changedTouches[0].clientX - startX;
        const dy = event.changedTouches[0].clientY - startY;
        // Ignore short or mostly-vertical gestures.
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;

        const panel = activePanel();
        // No active panel — nothing to swipe.
        if (!panel) return;

        const cards = slideCards(panel);
        const index = cards.findIndex((card) => card.getAttribute('aria-current') === 'true');
        // No active card found — bail.
        if (index < 0) return;

        const next = index + (dx < 0 ? 1 : -1);
        // Stay within the first/last card.
        if (next < 0 || next >= cards.length) return;
        setSlide(Number(cards[next].dataset.slide));
      }, { passive: true });
    });

    // Select the firmness tab that matches the current variant option value.
    function syncVariantTab() {
      // No variant data — skip auto-matching.
      if (!variants.length) return;

      const input = document.querySelector('input[name="id"]:checked, input[name="id"]');
      const select = document.querySelector('select[name="id"]');
      const id = input?.value || select?.value;
      // No selected variant on the PDP yet.
      if (!id) return;

      const variant = variants.find((item) => String(item.id) === String(id));
      const value = variant?.[variantOption];
      // Variant or configured option (e.g. option1) is missing.
      if (!value) return;

      const tabIndex = tabs.findIndex((tab) => tab.textContent.trim().toLowerCase() === String(value).toLowerCase().trim());
      // Switch layer only when a tab label matches the variant value.
      if (tabIndex > -1) setLayer(tabIndex);
    }

    // Recalculate carousel offset after layout changes.
    window.addEventListener('resize', () => {
      const panel = activePanel();
      const activeCard = panel?.querySelector('[data-slide-card][aria-current="true"]');
      // Re-sync track position for the currently selected card.
      if (activeCard) setSlide(Number(activeCard.dataset.slide));
    });

    document.addEventListener('change', (event) => {
      // Native variant picker change (radio/select).
      if (event.target.name === 'id') syncVariantTab();
    });
    // Theme/app variant change events (e.g. custom PDP scripts).
    document.addEventListener('variant:change', syncVariantTab);

    setLayer(0);
    syncVariantTab();
  }

  const root = document.querySelector('[data-bb-layers-root]');
  // Initialize only when the section is rendered on the page.
  if (root) initProductLayers(root);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  (function () {
    'use strict';

    // Bind footer newsletter once (Shopify injects this script once per section file).
    if (window.__bb_newsletter_bound) return;
    window.__bb_newsletter_bound = true;

    const KLAVIYO_REVISION = '2026-07-15';
    const MAX_RETRIES = 5;
    const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const ERROR_GENERIC = 'Unable to subscribe. Please try again.';

    // Resolve controls from the newsletter form.
    function form_parts(form) {
      return {
        form: form,
        button: form.querySelector('button[type="submit"]'),
        input: form.querySelector('#footer-newsletter-email'),
        fieldset: form.querySelector('fieldset'),
        error: form.querySelector('#footer-newsletter-error'),
        success: form.querySelector('#footer-newsletter-success'),
      };
    }

    // Toggle a message node; empty text hides it.
    function set_message(node, text) {
      if (!node) return;
      node.textContent = text || '';
      node.hidden = !text;
    }

    // Clear alert / status and input invalid state.
    function clear_messages(parts) {
      set_message(parts.error, '');
      set_message(parts.success, '');

      if (!parts.input) return;
      parts.input.removeAttribute('aria-invalid');
      parts.input.removeAttribute('aria-describedby');
    }

    // Show an error in the existing alert node.
    function show_error(parts, message) {
      set_message(parts.error, message);

      if (!parts.input) return;
      parts.input.setAttribute('aria-invalid', 'true');
      parts.input.setAttribute('aria-describedby', 'footer-newsletter-error');
      parts.input.focus();
    }

    // Hide fields and show the configured success message.
    function show_success(parts) {
      if (parts.fieldset) parts.fieldset.hidden = true;

      set_message(
        parts.success,
        parts.form.getAttribute('data-success-message') || 'Thanks for subscribing!'
      );
    }

    // Wait before a retry attempt.
    function wait(ms) {
      return new Promise(function (resolve) {
        setTimeout(resolve, ms);
      });
    }

    // Build the Klaviyo client subscription payload.
    function subscribe_body(email, list_id, source) {
      return {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: source,
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                  subscriptions: {
                    email: {
                      marketing: {
                        consent: 'SUBSCRIBED',
                      },
                    },
                  },
                },
              },
            },
          },
          relationships: {
            list: {
              data: {
                type: 'list',
                id: list_id,
              },
            },
          },
        },
      };
    }

    // POST one subscribe attempt to Klaviyo client subscriptions.
    function subscribe_once(company_id, list_id, email, source) {
      return fetch(
        'https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(company_id),
        {
          method: 'POST',
          headers: {
            revision: KLAVIYO_REVISION,
            accept: 'application/vnd.api+json',
            'content-type': 'application/vnd.api+json',
          },
          body: JSON.stringify(subscribe_body(email, list_id, source)),
        }
      );
    }

    // Subscribe with retries on 429 / 5xx only.
    function subscribe_with_retry(company_id, list_id, email, source, attempt) {
      const try_number = attempt || 0;

      return subscribe_once(company_id, list_id, email, source).then(function (response) {
        // Klaviyo returns 202 Accepted on success.
        if (response.status === 202 || response.ok) return response;

        const retryable = response.status === 429 || response.status >= 500;
        if (!retryable || try_number >= MAX_RETRIES) throw new Error(ERROR_GENERIC);

        const retry_after = parseInt(response.headers.get('Retry-After'), 10);
        const delay = Number.isFinite(retry_after)
          ? retry_after * 1000
          : Math.min(1000 * Math.pow(2, try_number), 60000);

        return wait(delay).then(function () {
          return subscribe_with_retry(company_id, list_id, email, source, try_number + 1);
        });
      });
    }

    // Validate and subscribe from one newsletter form.
    function handle_subscribe(parts) {
      clear_messages(parts);

      const company_id = parts.form.getAttribute('data-klaviyo-company-id');
      const list_id = parts.form.getAttribute('data-klaviyo-list-id');
      const source = parts.form.getAttribute('data-klaviyo-source') || 'Footer';
      const email = parts.input ? String(parts.input.value || '').trim() : '';

      if (!company_id || !list_id) {
        show_error(parts, 'Newsletter is unavailable. Please try again later.');
        return;
      }

      if (!email || !EMAIL_PATTERN.test(email)) {
        show_error(parts, 'Please enter a valid email address.');
        return;
      }

      if (parts.button) parts.button.disabled = true;

      subscribe_with_retry(company_id, list_id, email, source)
        .then(function () {
          clear_messages(parts);
          show_success(parts);
        })
        .catch(function () {
          show_error(parts, ERROR_GENERIC);
          if (parts.button) parts.button.disabled = false;
        });
    }

    // Button click and Enter both fire submit; stop the native GET and run Klaviyo.
    document.addEventListener('submit', function (event) {
      const form = event.target.closest('[data-newsletter] form');
      if (!form) return;

      event.preventDefault();

      const parts = form_parts(form);
      if (!parts || !parts.input) return;

      handle_subscribe(parts);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["global-popup"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const popup = document.getElementById("global-popup");
    
    if (!popup) return;

    const popupContent = popup.querySelector(".global-popup-content");
    const closeBtn = popup.querySelector(".global-close-popup");
    const bodyDiv = document.body;

    // Handle body class changes to add/remove global-popup-open class
    function syncBodyClass() {
      bodyDiv.classList.toggle(
        "global-popup-open",
        Boolean(popup.classList.contains("show"))
      );
    }

    // Close popup
    function closePopup() {
      popup.classList.remove("show");
    }

    // Open popup with price data
    window.openPriceDetails = function (button, event) {
      // If event is provided, prevent default
      if (event) event.preventDefault();

      // Get price data
      const priceData = button && button.nextElementSibling;

      // If price data is found, show popup with price data
      if (priceData && popupContent) popupContent.innerHTML = priceData.innerHTML;

      // Show popup
      popup.classList.add("show");
    };

    // Add observer to handle body class changes
    const observer = new MutationObserver(syncBodyClass);
    observer.observe(popup, {
      attributes: true,
      attributeFilter: ["class"],
    });
    syncBodyClass();

    // If close button is found, add event listener to close popup
    if (closeBtn) {
      closeBtn.addEventListener("click", closePopup);
    }

    // Add event listener to close popup on overlay click
    popup.addEventListener("click", function (e) {
      if (e.target === popup) closePopup();
    });

    // Add event listener to close popup on Escape key
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && popup.classList.contains("show")) {
        closePopup();
      }
    });

    // Add event listener to open popup on price "view details" button click
    document.addEventListener("click", function (e) {
      const btn = e.target.closest(".price-view-details");

      // If button is not found or is a table header, return
      if (!btn || btn.tagName === "TH") return;

      // Open popup with price data
      window.openPriceDetails(btn, e);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
